import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class LeftIndent extends React.Component {
  render() {
    return (
      <Row className="styled-indent">
        <Col style={{ paddingLeft: "20px" }}>
          {this.props.children}
        </Col>
      </Row>
    );
  }
}

export default LeftIndent;
